import axios from 'axios';

export default axios.create();



// WEBPACK FOOTER //
// ./src/api/instance.js